import { mapGetters } from "vuex";

export const ContactUsMixin = {
  data: () => ({
    asiansContact: {
      contact_tg: "https://t.me/ac_ludwig",
      contact_email: "sales@asians.cloud",
    }
  }),
  computed: {
    ...mapGetters(["isNotTrustyCDN", "vendorInfo"]),
    isVendorInfoEmpty() {
      if (this.isNotTrustyCDN) {
        return false
      }
      return (
        !!this.vendorInfo &&
        !this.vendorInfo?.contact_email &&
        !this.vendorInfo?.contact_tg &&
        !this.vendorInfo?.contact_phone
      )
    },
    contact() {
      if (this.isNotTrustyCDN) {
        return this.asiansContact;
      } else {
        return this.vendorInfo ?? {};
      }
    }
  }
}